import { OrderBook, OrderStatus } from "./orderInterfaces";
import { StepInstrumentType, StepOrderSide } from "./stepInterfaces";
import { ISearchParameters, ITableReport } from "./TableInterfaces";

export interface IMarketmakingTaskSearchParam extends ISearchParameters {
  baseInsId: string;
}

export interface IMarketmakingTaskTableReport extends ITableReport {
  username: string;
  userId: number;
  applicationUsername: string;
  dailyLockProfitBuy: number;
  dailyLockProfitSell: number;
  snapshot_FairPrice: number;
  snapshot_BasePrice: number;
  threshold: number;
  lastSnapshotTime: string;
  lastSnapshotStr: string;
  isActive: boolean;
  optionName: string;
  optionId: number;
  baseInsFactor: number;
}

export interface IAddEditMarketmakingTask {
  id?: number;
  insId: number;
  accountId: string;
  threshold: number;
  dailyLockProfitBuy: number;
  dailyLockProfitSell: number;
}

export interface IOpenOrder {
  side: StepOrderSide;
  price: number;
  volume: number;
  row?: number;
}

export interface IMarketmakingOrderbookPairResp {
  fullOrderBook: OrderBook;
  dailyLockProfitBuy: number;
  dailyLockProfitSell: number;
  calcBuyPrice: number;
  calcSellPrice: number;
  openOrders: IOpenOrder[];
}

export interface IMarketmakingConfig {
  riskFreeRate: number;
}

export enum MarketmakingTableTabs {
  OrderTable = 1,
  TradeTable,
  ErrorsTable,
  Program,
}

export interface IMarketmakingTradeTableSearchParams extends ISearchParameters {
  taskId?: number;
  accountId?: number;
  optionInstrumentId?: string;
}

export interface IMarketmakingOrderTableSearchParams extends ISearchParameters {
  taskId?: number;
}

export interface IMarketmakingOrderTableReport extends ITableReport {
  orderSide: StepOrderSide;
  orderSideClassname: string;
  sahraName: string;
  operator: string;
  namad: string;
  optionType: string;
  totalSize: number;
  firstStep: number;
  lastStep: number;
  stepCount: number;
  doneStepCount: number;
  filledVolume: number;
  errorCount: number;
  date: string;
  instrumentType: StepInstrumentType;
  instrument: string;
  baseInstrument: string;
  optionInstrument: string;
  orderStatus: OrderStatus;
  isActive: true;
  userId: number;
}

export interface IMarketmakingTradeTableReport extends ITableReport {}

export interface IMarketmakingProgram {
  buy: IMarketingProgramRowItem[];
  sell: IMarketingProgramRowItem[];
  deviationAmount: number;
  deviationPercent: number;
}

export interface IMarketingProgramRowItem {
  no: number;
  from: string;
  to: string;
  flexibilityPercent: number;
  flexibilityAmount: number;
}

export interface IMarketmakingTriggerTableReport extends ITableReport {}

export interface IMarketmakingSetProgramBody extends IMarketmakingProgram {
  taskId: number;
}

export interface IMarketmakingPredefinedProgram extends IMarketmakingProgram {
  id?: number;
  programName: string;
}

export interface IPreviewOffer {
  fromVolume: number;
  toVolume: number;
  calculatedPrice: number;
}

export interface IGetPreviewOfferResp {
  buy: IPreviewOffer[];
  sell: IPreviewOffer[];
  taskId: number;
  goodCondition: boolean;
}

export interface IFirstRowDelta {
  deltaAmount: number;
  deltaPercent: number;
}

export interface IManualConfig {
  ins1: string;
  ins2: string;
  auto: boolean;
}

export interface IManualConfigDTO {
  groupId: number;
  cs: IManualConfig;
  ps: IManualConfig;
}
